<template>
  <div class="box">
    <saveMapTip class="saveMapTip" v-if="saveMapFlag" />
    <div class="compass">
      <img src="@/assets/views/map/icon/compass.png" alt />
    </div>
    <deleteMap
      class="deleteMapConfirm"
      v-if="deleteMapFlag"
      @del="mapLDataDel"
      @notdel="cancelDel"
    />
    <uploadTip class="upload-tip" v-if="uploadMapFlag" />
    <div class="list" v-show="!handleShow">
      <div class="menu">
        <div class="layer-class" ref="layer" @click="layerChange">
          <span>图层</span>
        </div>
        <div class="path-class" ref="path" @click="pathChange">
          <span>路径</span>
        </div>
      </div>
      <div class="block" v-if="layerMenu">
        <div class="mapC">
          <div>C端地图</div>
          <div>
            <span>{{mapCwidth}}</span>
            <span v-if="mapCwidth" class="cross">&#10005</span>
            <span>{{mapCheight}}</span>
          </div>
        </div>
        <div class="mapCUpload">
          <upload tipInfo1="请上传c端展示地图" tipInfo2="支持.svg格式" ref="mapC" @upload-img="saveMapC" />
          <div class="delete-map" v-if="mapCload">
            <i class="el-icon-delete" @click="mapCdelete"></i>
          </div>
        </div>
        <div class="mapL">
          <div>标注地图</div>
          <div>
            <span>{{mapLwidth}}</span>
            <!-- <span v-if="mapLwidth" >&#10005</span> -->
            <span v-if="mapLwidth" class="cross">&#10005</span>
            <!-- <span><img style="width:100%;height:100%" src="@/assets/views/map/icon/timg.png" alt=""></span> -->
            <span>{{mapLheight}}</span>
          </div>
        </div>
        <div class="mapLUpload">
          <upload tipInfo1="请上传标注地图" tipInfo2="支持.jpg或.png格式" ref="mapL" @upload-img="saveMapL" />
          <div class="delete-map" v-if="mapLload">
            <i class="el-icon-delete" @click="mapLdelete"></i>
          </div>
        </div>
        <div class="dir-text">
          <span>设置正北</span>
        </div>

        <div class="dir-bar">
          <div class="sliderBox">
            <span>
              方位角
              <el-input
                style="width:60px;height:30px;margin-left:30px;"
                size="mini"
                @change="rotateInput"
                v-model="dirValue1"
              ></el-input>
            </span>
            <el-slider :max="360" v-model="dirValue" @change="rotateImg"></el-slider>
          </div>
        </div>
      </div>

      <div class="block" v-else>
        <div class="drawTable">
          <div class="mapDraw">
            <span>路径绘制</span>
          </div>

          <div class="mapDrawPlane">
            <span class="drawInfo">点击选择相应功能开始路径绘制</span>
            <draw ref="draw" class="draw" @chooseFun="drawFun" />
          </div>
          <div class="posInfo">
            <span>点位信息</span>
          </div>
          <div v-if="!choosePoint" class="posAttibuteNo">
            <span class="choose-point">点击选择需要编辑的点位</span>
          </div>
          <div v-else class="posAttibute">
            <div class="pointId">
              <span>点位ID</span>
              <span>{{pointId}}</span>
            </div>
            <div class="pointInfo">
              <span>点位名称</span>
              <span>
                <el-input size="mini" ref="inputPointName" v-model="pointName" @change="inputName"></el-input>
              </span>
            </div>
            <div class="selectTypeClass">
              <span>类型</span>
              <span>
                <selectType ref="pointType" @getTypeValue="getTypeValue" />
              </span>
            </div>
            <div class="pointLogo">
              <span>点位logo</span>
              <span>
                <upload ref="logo" @upload-img="initIcon" class="logoImg" />
                <div class="delete-icon" v-if="iconload">
                  <i class="el-icon-delete" @click="logoDelete"></i>
                </div>
              </span>
            </div>
          </div>
          <div class="save-data">
            <div class="saveBtn" @click="saveData">
              <img src="@/assets/views/map/icon/save.png" /> &nbsp保存标注
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="handleShow" class="boxMask">
      <div class="warnList">
        <img src="../../../assets/views/map/warning1.png" class="warning-img" />
        <p class="warning-message">地图对齐后</p>
        <p class="warning-message">才可以进行路径绘制</p>
      </div>
    </div>
    <div id="viewer" ref="viewer" @mousedown="labelMouseDown"></div>
  </div>
</template>

<script>
import Label from "./js/label";
import upload from "./upload";
import selectType from "./selectType";
import draw from "./draw";
import saveMapTip from "./save-map-tip";
import deleteMap from "./delete-mapl";
import uploadTip from "./tip";
export default {
  name: "Mark",
  data() {
    return {
      layerMenu: !0,
      pointBtnBool: !!0,
      lineBtnBool: !!0,
      adsorbBtnBool: !!0, //吸附
      pointName: "",
      pointId: "",
      mapCwidth: "",
      mapCheight: "",
      mapLwidth: "",
      mapLheight: "", //标注地图宽高
      mapCimg: "",
      mapLimg: "",
      mapLogoImg: "",
      iconList: [],
      pointOptions: [],
      pointType: "",
      handleShow: !!0,
      mapLload: !!0, //标注地图是否上传
      mapCload: !!0, //c端地图是否上传
      iconload: !!0,
      saveMapFlag: !!0, //是否保存地图,
      deleteMapFlag: !!0,
      uploadMapFlag: !!0,
      choosePoint: !!0, //是否选中点
      options: [], //种类
      dirValue: 0,
      dirValue1: 0
    };
  },
  components: {
    upload,
    selectType,
    draw,
    saveMapTip,
    deleteMap,
    uploadTip
  },
  created() {
    // console.log(this.$route.params.mapId, this.$store.state.storeId);
  },
  mounted() {
    this.init();
    this.initPaintingMap();
    this.isAlign();
    // console.log(this.$store.state.alignFlag,!0,!1);
    // console.log(!!this.$store.state.alignFlag);

    // this.handleShow = this.$store.state.alignFlag ? !!0 : !0;
    // console.log(this.handleShow);

    //可函数节流进行优化

    // window.onresize = function reSize() {
    //   // console.log(this.$refs.view.offsetHeight, this.$refs.view.offsetWidth);

    //   this.label.onWindowResize(
    //     this.$refs.viewer.offsetHeight,
    //     this.$refs.viewer.offsetWidth
    //   );
    // }.bind(this);
  },
  beforeDestroy() {
    // do something before destroying vue instance
    if (this.label) this.label.clear();
  },
  methods: {
    async isAlign() {
      const { data } = await this.$http.post(
        "/navigation/init-navigation-map",
        {
          map_id: this.$route.params.mapId
        }
      );
      // console.log(data);
      if (data.error_no === 200) {
        this.$store.commit("getAlign", data.data.is_aligned);
        this.handleShow = data.data.is_aligned === 0 ? !0 : !!0;
      }
    },
    async getCate() {
      //获取种类
      // console.log(this.$store.state.storeId);
      const { data } = await this.$http.post("/navigation/category", {
        store_id: this.$store.state.storeId
      });
      // console.log(data);
      this.options = data.data.categories;

      // console.log(this.options);
    },
    isnotLine(model) {
      if (model && model.name !== "line") return !0;
      else return !!0;
    },
    getTypeValue(type) {
      this.pointType = type;
      this.label.pointType = this.pointType;
      this.isnotLine(this.label.model)
        ? (this.label.model.pointType = this.pointType)
        : null;
    },
    inputName() {
      //输入和更改点信息
      // console.log(e.target.value);
      // console.log(this.$refs.inputPointName);

      this.pointName = this.$refs.inputPointName.value;
      this.label.pointName = this.pointName;

      //更改点的信息
      this.isnotLine(this.label.model)
        ? (this.label.model.pointName = this.pointName)
        : null;
    },
    init() {
      this.label = new Label("#viewer");
      // this.label.stackModels = [];
      // console.log(this.label.stackModels);

      // window.label = this.label;
    },
    async initPaintingMap() {
      //页面初始化
      const { data } = await this.$http.post("/navigation/init-paintingmap", {
        store_id: this.$store.state.storeId
      });
      this.getCate();
      this.layerChange();
      if (!data.data.painting_map_info) return;
      // this.mapCimg = data.data.painting_map_info.client_map;
      // this.mapLimg = data.data.painting_map_info.label_map;
      this.initModel(data.data.painting_map_info.label_map);
      this.getResolution(data.data.painting_map_info.client_map);

      this.$nextTick(() => {
        this.$refs.mapC.imageUrl = data.data.painting_map_info.client_map;
        this.$refs.mapL.imageUrl = data.data.painting_map_info.label_map;
      });
      setTimeout(() => {
        // console.log(data.data.painting_map_info.label_data);

        this.label.importData(data.data.painting_map_info.label_data);
        // this.getPanoPoint();
      }, 2500);
    },
    async getPanoPoint() {
      // console.log(this.$refs.mapC.file, this.$refs.mapL.file);

      // store_id: 3MsxxfdfrYZ53vm4,
      const width = !this.mapLwidth ? 0 : this.mapLwidth;
      const height = !this.mapLheight ? 0 : this.mapLheight;
      console.log(width, height);

      try {
        const {
          data: { data }
        } = await this.$http.post("/navigation/panorama-position", {
          store_id: this.$store.state.storeId,
          width: width,
          height: height
        });
        console.log(data);
        this.label.initPanoPoint(data.panorama_position);
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    initModel(img) {
      // console.log(this.$store.state.storeId);
      //清空之前的标注等
      this.mapLimg = img;
      // console.log(img);

      // this.label.clear();
      this.label.initModel(img);
      this.label.getResolution(img, (w, h) => {
        this.mapLwidth = w;
        this.mapLheight = h;
        if (this.mapLwidth || this.mapLheight) this.mapLload = !0;
      });

      //获取全景点位
      // console.log(this.getPanoPoint());
    },
    getResolution(img) {
      // console.log(this.$refs.mapC);

      //get image resolution
      this.label.getResolution(img, (w, h) => {
        this.mapCimg = img;
        this.mapCwidth = w;
        this.mapCheight = h;
        if (this.mapCwidth || this.mapCheight) this.mapCload = !0;
      });
    },

    initIcon(img) {
      this.mapLogoImg = img;
      // this.iconList.push(img);
      this.label.model.iconUrl = img;
      this.iconload = !0;
      // console.log(this.iconList);

      // this.label.addSprite(name);
      // this.label.addInflectionSprite(name);

      // let formData = new FormData();
      // formData.append("icon", this.$refs.logo.file.raw);
      // // console.log(formData.get("icon"));

      // this.axios
      //   .post("/saveIcon", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   })
      //   .then(response => {
      //     console.log(response.data);
      //   })
      //   .catch(response => {
      //     console.log(response);
      //   });
    },
    layerChange() {
      this.layerMenu = !0;
      this.$nextTick(() => {
        this.$refs.mapC.imageUrl = this.mapCimg;
        this.$refs.mapL.imageUrl = this.mapLimg;
      });

      this.backGroudColorChange(this.$refs.layer.style, this.$refs.path.style);
    },
    pathChange() {
      this.layerMenu = !!0;
      this.$nextTick(() => {
        // this.$refs.logo.imageUrl = this.mapLogoImg;
        // this.pointOptions.length > 0
        //   ? (this.$refs.pointType.options = this.pointOptions) &&
        //     (this.$refs.pointType.value = this.pointType)
        //   : this.$refs.pointType.getCate();
      });
      this.backGroudColorChange(this.$refs.path.style, this.$refs.layer.style);
    },
    backGroudColorChange(a, b) {
      a.backgroundColor = "#393939";
      b.backgroundColor = "#282828";
    },
    mapCdelete(e) {
      this.$refs.mapC.imageUrl = null;
      this.mapCwidth = "";
      this.mapCheight = "";
      this.mapCimg = "";
      this.mapCload = !!0;
      this.deleteMap();
      this.mapCload = !!0;
    },
    mapLdelete(e) {
      this.deleteMapFlag = !0;
    },
    mapLDataDel() {
      this.$refs.mapL.imageUrl = null;
      this.mapLwidth = "";
      this.mapLheight = "";
      this.mapLimg = "";
      this.mapload = !!0;
      this.deleteMapFlag = !0;
      this.label.clear();
      this.deleteMapFlag = !!0;
      // console.log(this.mapLimg);

      this.deleteMap();
      this.mapLload = !!0;
      this.saveData();
    },
    cancelDel() {
      this.deleteMapFlag = !!0;
    },
    logoDelete(e) {
      this.$refs.logo.imageUrl = null;
      this.mapLogoImg = "";
      this.iconload = !!0;
    },
    drawFun(index, mutual) {
      // console.log(index);
      switch (index) {
        case 0:
          if (mutual) {
            this.pointBtnBool = !!0;
            this.closePoint();
          }
          this.lineBtnBool = !this.lineBtnBool;
          this.lineBtnBool ? this.addLine() : this.closeLine();
          break;
        case 1:
          if (mutual) {
            this.lineBtnBool = !!0;
            this.closeLine();
          }
          this.pointBtnBool = !this.pointBtnBool;
          this.pointBtnBool ? this.addPoint() : this.closePoint();
          break;
        case 2:
          this.adsorbBtnBool = !this.adsorbBtnBool;
          this.adsorbBtnBool
            ? this.label.adsorb()
            : (this.label.adsorbPoint = null);
          break;
        case 3:
          this.label.backOut();
          break;
        case 4:
          this.label.deleteModel();
          break;
        default:
          break;
      }
    },

    labelMouseDown(e) {
      //右键取消绘制
      if (e.which === 3) {
        if (this.pointBtnBool) {
          this.closePoint();
          this.$refs.draw.giveupIcon(1);
          this.$refs.draw.outStyle(1);

          this.pointBtnBool = !!0;
        }

        if (this.lineBtnBool) {
          this.closeLine();
          this.$refs.draw.giveupIcon(0);
          this.$refs.draw.outStyle(0);
          this.lineBtnBool = !!0;
        }
      } else if (e.which === 1) {
        //this.$nextTick
        setTimeout(() => {
          if (this.label.addNewPoint) {
            // this.pointId = this.label.addNewPoint.pointId;
            // this.$refs.logo.imageUrl = this.mapLogoImg;
            // this.$refs.pointType.value = this.pointType;
          } else if (this.label.model) {
            if (this.label.model.name === "line") {
              this.choosePoint = !!0;
              return;
            }
            this.choosePoint = !0;
            this.pathChange();

            this.pointId = this.label.model.pointId;

            this.pointName = this.label.model.pointName;

            this.pointType = this.label.model.pointType;

            this.mapLogoImg = this.label.model.iconUrl;
            // console.log(this.label.model);

            this.$nextTick(() => {
              this.$refs.pointType.value = this.label.model.pointType;
              this.$refs.logo.imageUrl = this.label.model.iconUrl;
              this.$refs.pointType.options = this.options;
            });
          } else {
            this.choosePoint = !!0;
            // this.pointId = "";
            // this.pointName = "";
            // // this.pointType = "";

            // this.$refs.pointType
            //   ? (this.$refs.pointType.value = this.pointType)
            //   : null;
            // this.$refs.logo
            //   ? (this.$refs.logo.imageUrl = this.mapLogoImg)
            //   : null;
          }

          // console.log(this.pointName);
        }, 100);
      }
    },
    addPoint() {
      //add Point
      // this.label.addSprite(img);

      this.label.pointName = this.pointName;
      this.label.pointType = this.pointType;
      this.label.pointBool = !0;
    },
    closePoint() {
      this.label.pointBool = !!0;
    },
    addLine() {
      // add Line
      this.label.lineBool = !0;
      this.label.pointName = this.pointName;
      this.label.pointType = this.pointType;
      // this.label.addInflectionSprite(img);
      // this.label.addSprite(img);
      this.label.addLine();
    },
    closeLine() {
      this.label.lineBool = !!0;
      this.label.finishAddLine();
    },
    backOut() {
      this.label.backOut();
    },
    adsorb() {
      this.label.adsorb();
    },
    deleteModel() {
      this.label.deleteModel();
    },
    clearLabels() {
      this.label.clear();
    },
    async deleteMap() {
      const width = !this.mapLwidth ? 0 : this.mapLwidth;
      const height = !this.mapLheight ? 0 : this.mapLheight;
      const { data } = await this.$http.post("/navigation/save-paintingmap", {
        store_id: this.$store.state.storeId,
        label_map: this.mapLimg,
        client_map: this.mapCimg,
        width: width,
        height: height
      });

      // .then(
      //   setTimeout(() => {
      //     // this.$message.basic({
      //     //   message: "地图已上传"
      //     // });
      //     this.uploadMapFlag = !0;
      //     setTimeout(() => {
      //       this.uploadMapFlag = !!0;
      //     }, 1500);
      //   }, 0)
      // );
    },
    async saveMapC(img) {
      this.mapCimg = img;
      // console.log(this.mapLimg);
      this.getResolution(this.mapCimg);
      const width = !this.mapLwidth ? 0 : this.mapLwidth;
      const height = !this.mapLheight ? 0 : this.mapLheight;
      const { data } = await this.$http.post("/navigation/save-paintingmap", {
        store_id: this.$store.state.storeId,
        label_map: this.mapLimg,
        client_map: this.mapCimg,
        width: width,
        height: height
      });
    },
    async saveMapL(img) {
      this.label.clear();
      this.saveData1();
      this.mapLimg = img;
      // console.log(this.mapLimg);
      this.initModel(this.mapLimg);
      const width = !this.mapLwidth ? 0 : this.mapLwidth;
      const height = !this.mapLheight ? 0 : this.mapLheight;
      const { data } = await this.$http.post("/navigation/save-paintingmap", {
        store_id: this.$store.state.storeId,
        label_map: this.mapLimg,
        client_map: this.mapCimg,
        width: width,
        height: height
      });

      setTimeout(() => {
        this.getPanoPoint();
      }, 2200);
    },
    async saveMap1() {
      // console.log(this.$refs.mapC.file, this.$refs.mapL.file);
      // console.log(this.mapLimg);
      // console.log(
      //   this.$store.state.storeId,
      //   this.mapCimg,
      //   this.mapLimg,
      //   this.mapCwidth,
      //   this.mapCheight
      // );
      const width = !this.mapLwidth ? 0 : this.mapLwidth;
      const height = !this.mapLheight ? 0 : this.mapLheight;
      this.saveData();
      const { data } = await this.$http
        .post("/navigation/save-paintingmap", {
          store_id: this.$store.state.storeId,
          label_map: this.mapLimg,
          client_map: this.mapCimg,
          width: width,
          height: height
        })
        .then(
          setTimeout(() => {
            // this.$message.basic({
            //   message: "地图已上传"
            // });
            this.uploadMapFlag = !0;
            setTimeout(() => {
              this.uploadMapFlag = !!0;
            }, 1500);
          }, 0)
        );
      // console.log("saveMap", data);
      this.getPanoPoint();
    },
    async saveData() {
      //save data
      const label_data = this.label.exportData();

      // console.log(label_data);
      const { data } = await this.$http
        .post("/navigation/save-label-data", {
          store_id: this.$store.state.storeId,
          label_data: label_data
        })
        .then(
          setTimeout(() => {
            // this.$message.basic({
            //   message: "地图已上传"
            // });
            this.uploadMapFlag = !0;
            setTimeout(() => {
              this.uploadMapFlag = !!0;
            }, 1500);
          }, 0)
        );
      // console.log("saveData", data);
    },
    async saveData1() {
      //save data
      const label_data = this.label.exportData();

      // console.log(label_data);
      const { data } = await this.$http.post("/navigation/save-label-data", {
        store_id: this.$store.state.storeId,
        label_data: label_data
      });
      // console.log("saveData", data);
    },
    rotateInput(e) {
      // console.log(e,typeof(e));
      this.dirValue = Number(e);
      this.rotateImg(this.dirValue);
    },
    rotateImg(e) {
      // console.log(e);
      this.dirValue1 = e;
      const img = document.querySelector(".compass");
      img.style.transform = `rotate(${e}deg)`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import url("../stylus/mark.scss");
</style>
